module.exports = __webpack_public_path__ + "static/media/GelBoxFullOpen.7c5c5091.svg";